import useApi, { ApiOptions } from '../base/useApi';
import InventoryDTO from '@src/adapters/dto/inventory/InventoryDTO';

interface Params {
  inventory: InventoryDTO;
}

interface Result {
  inventory: InventoryDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/inventory',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveInventoryLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveInventoryLazy;
